import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import './PendingOffers.css';

function PendingOffers() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPendingOffers();
  }, []);

  const fetchPendingOffers = async () => {
    try {
      setLoading(true);
      const response = await api.get('/offers?status=pending');
      setOffers(response.data.data);
    } catch (error) {
      console.error('Bekleyen teklifler yüklenemedi:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    if (!window.confirm('Bu teklifi onaylamak istediğinizden emin misiniz?')) return;
    
    try {
      await api.put(`/offers/${id}/approve`);
      alert('Teklif onaylandı!');
      fetchPendingOffers();
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.message || 'İşlem başarısız'));
    }
  };

  const handleReject = async (id) => {
    const reason = prompt('Red nedeni:');
    if (!reason) return;
    
    try {
      await api.put(`/offers/${id}/reject`, { reason });
      alert('Teklif reddedildi!');
      fetchPendingOffers();
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.message || 'İşlem başarısız'));
    }
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('tr-TR');
  };

  const formatCurrency = (amount, currency) => {
    const symbols = { EUR: '€', USD: '$', TRY: '₺', GBP: '£' };
    return `${Math.round(amount)} ${symbols[currency] || currency}`;
  };

  return (
    <div className="pending-offers-page">
      <div className="page-header">
        <h1>⏳ Onay Bekleyen Teklifler</h1>
        <button className="btn-back" onClick={() => navigate('/dashboard')}>
          ← Dashboard
        </button>
      </div>

      {loading ? (
        <div className="loading">Yükleniyor...</div>
      ) : offers.length === 0 ? (
        <div className="no-pending">
          <h2>✅ Bekleyen teklif yok!</h2>
          <p>Tüm teklifler işlendi.</p>
        </div>
      ) : (
        <div className="pending-list">
          {offers.map((offer) => (
            <div key={offer.id} className="pending-card">
              <div className="card-header">
                <h3>{offer.offer_number}</h3>
                <span className="date">{formatDate(offer.offer_date)}</span>
              </div>
              
              <div className="card-body">
                <div className="info-row">
                  <strong>Müşteri:</strong>
                  <span>{offer.customer_name}</span>
                </div>
                <div className="info-row">
                  <strong>Firma:</strong>
                  <span>{offer.company_name}</span>
                </div>
                <div className="info-row">
                  <strong>Hazırlayan:</strong>
                  <span>{offer.prepared_by}</span>
                </div>
                <div className="info-row">
                  <strong>Toplam:</strong>
                  <span className="total">{formatCurrency(offer.total, offer.currency)}</span>
                </div>
              </div>
              
              <div className="card-actions">
                <button className="btn-view" onClick={() => navigate(`/offers/${offer.id}`)}>
                  👁️ Görüntüle
                </button>
                <button className="btn-approve" onClick={() => handleApprove(offer.id)}>
                  ✓ Onayla
                </button>
                <button className="btn-reject" onClick={() => handleReject(offer.id)}>
                  ✗ Reddet
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PendingOffers;
